import { createContext, useContext, type ReactNode } from "react";
import type { MeDto, Permission } from "@platform/core";
import type { ApiClient } from "./api/client";
import type { ConsoleAuth } from "./auth";
import type { RuntimeConfig } from "./config";

export interface ConsoleContextValue {
  config: RuntimeConfig;
  auth: ConsoleAuth;
  api: ApiClient;
  me: MeDto;
  productName: string;
  can: (p: Permission) => boolean;
}

const Ctx = createContext<ConsoleContextValue | null>(null);

export function ConsoleProvider({ value, children }: { value: ConsoleContextValue; children: ReactNode }) {
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useConsole(): ConsoleContextValue {
  const v = useContext(Ctx);
  if (!v) throw new Error("useConsole must be used inside ConsoleProvider");
  return v;
}

export function useApi(): ApiClient {
  return useConsole().api;
}
